import React from "react";
import { useHotkey } from "@react-hook/hotkey";

import { Fab, CircularProgress, Tooltip } from "@mui/material";
import { ContentSave as SaveIcon } from "mdi-material-ui";

const COMMAND_KEY =
  typeof window !== "undefined" && window.navigator.platform === "MacIntel"
    ? "⌘"
    : "Ctrl";

export default function SaveFab({ disabled, loading, onSave, ...props }) {
  useHotkey(window, ["mod", "s"], (e) => {
    e.preventDefault();
    if (disabled || loading) return;
    onSave();
  });

  return (
    <Tooltip title={`Enregistrer (${COMMAND_KEY} + S)`}>
      <span>
        <Fab disabled={disabled || loading} {...props} onClick={onSave}>
          {loading ? <CircularProgress size={24} /> : <SaveIcon />}
        </Fab>
      </span>
    </Tooltip>
  );
}

SaveFab.defaultProps = {
  color: "primary",
  size: "small",
};
